export default "__VITE_ASSET__CPuNvJZK__"